<template>
  <div class="mine page"><div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
         <div style="width: 100%;height: 13.33333rem;background: url(/img/home/usertop.f1d3af97.png) no-repeat 50% / 100%;"><div class="header">
           <van-nav-bar class="nav-bar">
             <template #right>
               <!-- <van-icon name="setting-o" @click="showSetting()" color="#fff"/> -->
               <div style="padding: 10px 0px 0px 0px;">
                 <img style="height:30px" src="/img/home/xx.png" @click="$router.push({path:'/Notice'});" />
               </div>
             </template>
           </van-nav-bar><div style="width: 100%;padding: 0 6%;display: flex;justify-content: flex-start;align-items: center;margin-top: 1.33333rem;">
<div style="border: 4px solid #fff;width: 60px;height: 60px;border-radius: 30px;position: relative;display: inline-block;" @click="doLogin()"><img style="object-fit: cover;width:58px;border-radius: 29px;" src="/img/home/avatar.png"></div>
<div style="height: 6px;display: flex;flex-direction: column;justify-content: center;align-items: flex-start;padding-left: 1.33333rem;flex: 1;font-size: 12px;">
	<div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;width: 100%;height: 60px;">
		<div style="width: 100%;height: 24px;font-size: 13px;line-height: 24px;text-align: left;color:#fff">{{this.userInfo.username}}<span style="align-items: center;
    font-weight: 600;
    padding: .06667rem .13333rem;
    border-radius: .13333rem;
    font-size: 13PX;
    margin-left: .33333rem;
    background: linear-gradient(#ffac38, #ffda05);">{{this.userInfo.lv_name}}</span></div><div style="width: 100%;height: 24px;font-size: 13px;line-height: 24px;text-align: left;color:#fff">{{$t("foorter.top20")}}:{{this.userInfo.score}}</div>
	</div>
</div><van-icon name="arrow" @click="doLogin()"/>
</div></div></div>
<div style="width: 94%;margin: -4.33333rem auto 0;"><div style="width: 94%;background: url(/img/home/mk2s.f860028b.png) no-repeat top / 100%;display: flex;justify-content: center;align-items: center;padding: .66667rem .66667rem;border-radius: .33333rem;margin: .66667rem auto 0;box-shadow: 0 .13333rem .2rem rgba(0, 0, 0, .04);">
<div style="display: flex;
    padding: 0 0 0;
    width: 90%;
    margin: 0 auto;
    justify-content: flex-start;
    align-items: center;">
	<img class="van-icon__image" src="data:image/png;base64,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">
	<div style="color: #fff;font-size: 10px;font-weight: 600;margin-left: .66667rem;">	{{$t("my.activity_points")}}{{ this.userInfo.money }}</div>
</div><div style="width: 43%;margin: 0 auto;display: flex;justify-content: flex-end;align-items: center;">
<div style="color: #ebe6d0;font-size: .86667rem;top: 0;bottom: 0;margin: auto;right: 1.33333rem;display: flex;justify-content: flex-start;align-items: center;"><span style="padding-right: .33333rem;">{{$t("reservation.unit")}}</span><img @click="shuaxin()" class="van-icon__image" src="data:image/png;base64,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" style="width:16px"></div>
</div>
</div>
<div style="width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
    align-items: center;
    border-radius: .66667rem;
    position: relative;
    z-index: 999;
    margin-top: -.33333rem;">
	<div @click="$router.push('/Recharge')" style="width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;"><img style="display: block;
    width: 32px;
    height: 32px;
    -o-object-fit: contain;
    object-fit: contain;
" class="van-icon__image" src="/img/home/czjf.13452b89.png">
<div style="text-align: center;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;"><span style="margin-left: .66667rem;
    color: #0d2144;
    font-weight: 400;font-size: 12PX;"> {{$t("foorter.top21")}}</span><p style="color: #787b82;
    font-size: 12PX;
    margin-left: .66667rem;">{{$t('recharge.recharge')}}</p></div>
</div><div @click="doWithdrawal()" style="width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;"><img style="display: block;
    width: 32px;
    height: 32px;
    -o-object-fit: contain;
    object-fit: contain;
" class="van-icon__image" src="/img/home/jfdh.54afd521.png">
<div style="text-align: center;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;"><span style="margin-left: .66667rem;
    color: #0d2144;
    font-weight: 400;font-size: 12PX;"> {{$t("withdraw.with_center")}}</span><p style="color: #787b82;
    font-size: 12PX;
    margin-left: .66667rem;">{{$t('my.withdraw')}}</p></div>
</div>
	</div>
</div>
<div style="width: 100%;border-top: .6rem solid #f6f8fa;margin-bottom: 50px;">
	<div style="width: 100%;background: #fff;display: flex;justify-content: center;padding: 0 0;align-items: center;flex-wrap: wrap;border-radius: .33333rem;margin-top: 0;">
			<div @click="toServicePage()" style="height:70px;width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="data:image/png;base64,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">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("my.online_service")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			
			<div @click="doLogin()" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/jb.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("setting.base_setting")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			
			<!-- <div @click="toServicePage()" style="display:none;width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/jf.b7ac15ae.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("foorter.top22")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div> -->
			<div @click="$router.push({path:'/BindCard'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/7.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("my.msg39")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			<div @click="$router.push({path:'/BindUsdt'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 24px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/8.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">USDT-TRC20</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			
			
			<div @click="$router.push({path:'/WithdrawRecord'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/txjls.b557a239.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("withdraw.with_record")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			<div @click="$router.push({path:'/RechargeRecord'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 24px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/czjf.13452b89.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("foorter.ti_record")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			<div @click="$router.push({path:'/GameRecord'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/rw.116ac71c.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("foorter.top23")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			<div @click="$router.push({path:'/MoneyRecord'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/jf.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("auth.top33")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			
			<div @click="$router.push({path:'/Notice'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/gg.9da144ab.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("foorter.top24")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			
			<div @click="$router.push({path:'/SetLoginPassword'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/dl.f3672665.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("setting.login_pwd_tip")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div>
			
			<div @click="$router.push({path:'/SetPayPassword'});" style="width: 100%;display: flex;justify-content: flex-start;align-items: center;padding: .66667rem 0 1rem 6%;position: relative;height: 70px;">
				<img style="display: block;width: 38px;height: 38px;-o-object-fit: contain;object-fit: contain;" class="van-icon__image" src="/img/home/dl.f3672665.png">
				<p style="color: #432788;padding: .53333rem 6px;font-size: 16px;">{{$t("setting.set_money_pwd")}}</p>
				<van-icon name="arrow" style="position: absolute;right: 20px;"/>
			</div><div style="display: inline-block;margin-left: 5%;text-align: center;margin-bottom: 20px;
    width: 80%;
    background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    padding: .86667rem 0;
    border-radius: .33333rem;
    font-size: .93333rem;
    cursor: pointer;
    margin: 1.66667rem auto 3.33333rem;" @click="loginout()" >{{$t("setting.logout")}}</div>
	</div>
	
	
</div>
         <div class="content" style="display: none;">
            <div class="finance">
             
              <!-- @click="toService()" -->
            <div class="finance-item"  @click="doWithdrawal()">
              <van-icon class="icon" style="" name="data:image/png;base64,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" />
              <span class="text">{{$t("my.exchange")}}</span>
            </div>
           
            <!-- <div class="finance-item"  @click="doWithdrawal()">
              <van-icon class="icon" name="idcard" />
              <span class="text">{{$t("my.withdraw")}}</span>
            </div> -->
          </div>
        
            <div  class="wallet">
                <div class="part-1 van-hairline--bottom">
                  <p class="flex-1 font-28 font-primary-color">{{$t("my.activity_points")}}</p>
      
                </div>
                <div class="part-2">
                  <p class="balance van-ellipsis"></p>
                  <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->
                  <span class="font-28 font-gray">{{$t("reservation.unit")}}</span>
                  <div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
                </div>
                <div class="part-2 part-3">
                  <p class="balance van-ellipsis">{{ this.userInfo.money }}</p>
                  <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->
             
                </div>
            </div>
            
            <div :style="{ marginTop: menu_top +'px'}" class="menu" >
              <div class="menu-item" @click="$router.push({path:'/Infomation'});">
                <van-image class="menu-item-icon" src="/img/mine/nav1.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.basic_information")}}</span>
              </div>
              <div class="menu-item" @click="$router.push({path:'/SetLoginPassword'});">
                <van-image class="menu-item-icon" src="/img/mine/nav7.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.Login_password")}}</span>
                <!-- <span class="menu-item-label" >{{$t("my.account_detail")}}</span> -->
              </div>
              <div class="menu-item" @click="$router.push({path:'/GameRecord'});">
                <van-image class="menu-item-icon" src="/img/mine/baobiao.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.task_log")}}</span>
              </div>
              <div class="menu-item"  @click="toNotice()">
                <van-image class="menu-item-icon" src="/img/mine/4.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.sys_notice")}}</span>
              </div>
              <div class="menu-item" @click="toServicePage()">
                <van-image class="menu-item-icon" src="/img/mine/5.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.online_customer_service")}}</span>
              </div>
              <!-- <div class="menu-item" @click="toService()">
                <van-image class="menu-item-icon" src="img/mine/kefu_1.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.online_service")}}</span>
              </div> -->
            </div>
            <div class="btn">
              <van-button color="linear-gradient(90deg,#6529c9,#cc2996)"  style="margin: 20px 0;font-size: 16px;padding:25px 0;width: 100%;border-radius: 14px;" @click="loginout()" >
                {{$t("setting.logout")}}
</van-button>
            </div>
         </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      userInfo:{
      },
      menu_top:40,
      isLoading: false,
    };
  },
  methods: {
    refresh(){
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t("reservation.refresh"));
        }else{
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {this.kefu = res.data.kefu;
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    exit(){
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Setting'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
        }else{
            this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin(){
        if(localStorage.getItem('token')){
            this.$router.push({path:'/Infomation'});
        }else {
            this.$router.push({path:'/Login'})
        }
    },
    doPay(){
      this.$router.push({
        name:'Recharge',
        params:{
          'balance':this.userInfo.money
        }
      })
    },
    doWithdrawal(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
          if(res.data.is_bank){
            this.$router.push("withdraw");
          }else {
            this.$router.push("Setbank");
            this.$toast.fail(this.$t("setting.set_bank"));
          }
      })
    },
    toService() {
      console.log(this.$store.getters.getBaseInfo)
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("Withdraw");
      }else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },shuaxin(){
		this.getUserInfo();this.$toast(this.$t("reservation.refresh"));
	},getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
            console.log(this.userInfo);
            this.menu_top = 15;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },toServicePage(){
		console.log(this.kefu)
		window.location.href = this.kefu
      // this.$router.push("ServicePage");
    },
    loginout() {
      localStorage.clear()
      this.$router.push({path:'/Login'});
    }
  },
  created() {this.getBasicConfig();
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped>
.page{
  position: absolute!important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}
.mine{
width: 100%;
min-height: 100%;
padding-bottom: 2rem;
background: #fff;
}
.mine .wrapper{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.nav-bar{
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
      background: unset;padding: 0px;
}
.mine .header{

  padding-bottom: 100px;
  background-size: contain
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}
.mine .header .user-wrapper{
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}
.mine .user_img{
  height: 130px;
  width: 130px;
}
::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}
::v-deep .van-image__error-icon {
  font-size: 70px;
}
.mine  .header .user-wrapper .login-content{
  flex: 1;
  margin-left: 30px;
}
.mine  .header .user-wrapper .login-content .login-btn{
  display: inline-block;
  font-size: 40px;
  line-height: 0px;
  color: #fff;
}
.mine .header .user-wrapper .login-content .login-label{
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0,0%,100%,.6);
}
.mine .page-bg{
  height: 500px;

}
.mine .content{
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .finance .line{
  width: 3px;
  height: 40px;
  background-color: #ccc;
}
.mine .wrapper .content .finance .finance-item{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mine .wrapper .content .finance .finance-item .text{
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}
.mine .wrapper .content .finance .finance-item .icon{
  font-size: 50px;
}
.mine .wrapper .content .menu{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .menu .menu-item{
  display: flex;
  align-items: center;
 flex-direction: column;
  width: 33.3%;
  height: 180px;
}
.mine .wrapper .content .menu .menu-item .menu-item-label{
  font-size: 24px;
  color: #432788;
  font-weight: 500;
}
.mine .wrapper .content .menu .menu-item .menu-item-icon{
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}
.mine .wrapper .content .wallet{
  margin-top: 80px;
  padding: 0 30px;
  background-color: #a06098;
  border-radius: 15px;
 
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .wallet .part-1{
  display: flex;
  align-items: center;
  height: 100px;
}
.mine .wrapper .content .wallet .font-primary-color{
  color: #fff;
  font-size: 32px;
}
.font-gray {
  color: #fff;
  font-size: 28px;
}
.mine .wrapper .content .wallet .part-2{
  display: flex;
  align-items: center;
  height: 10px;
}
.mine .wrapper .content .wallet .part-3{
  display: flex;
  align-items: center;
  height: 80px;
}
.mine .wrapper .content .wallet .part-2 .balance{
  flex: 1;
  font-size: 60px;
  color: #fff;
  font-weight: 700;
}
/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn{
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}
.btn{
 margin: 40px 0;
}
</style>
